function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m0 248.058594v120c0 8.285156 6.714844 15 15 15h98.046875v-150h-98.046875c-8.285156 0-15 6.714844-15 15zm0 0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m316.003906 218.203125v-26.144531c0-.796875-.082031-1.570313-.199218-2.332032h-119.601563c-.121094.761719-.199219 1.539063-.199219 2.332032v26.164062l-21.683594 14.835938h-31.277343v150h33.328125c6.246094 0 11.378906 1.015625 17.160156 3.402344 3.722656 1.535156 7.816406 3.242187 12.023438 5 13.335937 5.5625 27.125 11.320312 35.230468 14.160156 5.050782 1.769531 10.132813 2.652344 15.21875 2.652344 5.082032 0 10.164063-.882813 15.210938-2.652344 10.363281-3.632813 32.128906-12.527344 47.613281-19.039063 5.871094-2.46875 11.089844-3.523437 17.453125-3.523437h32.761719v-150h-31.355469zm0 0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m497 233.058594h-97.957031v150h97.957031c8.285156 0 15-6.714844 15-15v-120c0-8.285156-6.714844-15-15-15zm0 0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m366 0h-220c-16.570312 0-30 13.433594-30 30s13.429688 30 30 30h220c16.570312 0 30-13.429688 30-30 0-16.566406-13.429688-30-30-30zm0 0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m226 90h60v69.726562h-60zm0 0"
});

var SvgPipe2 = function SvgPipe2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -52 512 512",
    width: "512pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPipe2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pipe2.c6df1c31.svg";
export { ForwardRef as ReactComponent };